import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.is-array.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { NumberUtils } from "./NumberUtils";
export var ProductFormBuilder = /*#__PURE__*/function () {
  function ProductFormBuilder() {
    _classCallCheck(this, ProductFormBuilder);
  }

  _createClass(ProductFormBuilder, null, [{
    key: "DrawForm",
    value: function DrawForm(container, data, labels) {
      container.classList.add("product-form");

      var _iterator = _createForOfIteratorHelper(data.optionGroups),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          var optionGroupContainer = document.createElement("DIV");
          optionGroupContainer.classList.add("mppw-form-field-alt");
          optionGroupContainer.classList.add("mpp-mt-10");
          var optionGroupLabel = document.createElement("h3");
          optionGroupLabel.innerHTML = group.required === true ? group.optionGroupName + " *" : group.optionGroupName;
          optionGroupContainer.appendChild(optionGroupLabel);
          var optionGroupDescription = document.createElement("p");
          optionGroupDescription.innerHTML = group.description;
          optionGroupContainer.appendChild(optionGroupDescription);
          var fieldControlContainer = document.createElement("DIV");
          fieldControlContainer.classList.add("product-form__control");
          var tableHtml = this.BuildTable();
          var tableHeader = this.BuildHeaderRow(labels);
          tableHtml.appendChild(tableHeader);

          if (!!group.mutuallyExclusive && group.required === false) {
            var tableNotSelectedRow = this.BuildNotSelectedRow(group.optionGroupId);
            tableHtml.appendChild(tableNotSelectedRow);
          }

          var _iterator2 = _createForOfIteratorHelper(group.optionPrices),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var price = _step2.value;

              if (price.isHidden == false) {
                // Determined by days out to hide in product data manager
                var tableRow = this.BuildOptionRow(group, price);
                tableHtml.appendChild(tableRow);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          fieldControlContainer.appendChild(tableHtml);
          optionGroupContainer.appendChild(fieldControlContainer);
          container.appendChild(optionGroupContainer);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      container.innerHTML += "<input type=\"hidden\" id=\"product-invoice-detail_".concat(data.productId, "\" name=\"product-invoice-detail_").concat(data.productId, "\" />");
    }
  }, {
    key: "BuildTable",
    value: function BuildTable() {
      var table = document.createElement("table");
      table.classList.add("mppw-product-options"); //table.setAttribute("border", "1");

      table.setAttribute("cellspacing", "0");
      table.style.width = "100%";
      return table;
    }
  }, {
    key: "BuildHeaderRow",
    value: function BuildHeaderRow(labels) {
      var headerRow = document.createElement("tr");
      var headerCell;
      headerCell = document.createElement("th");
      headerCell.classList.add("option-name");
      headerCell.innerHTML = labels.productOptionDescriptionLabel; //labels.optionDescription

      headerRow.appendChild(headerCell);
      headerCell = document.createElement("th");
      headerCell.classList.add("option-qty");
      headerCell.innerHTML = labels.productQtyLabel; //labels.optionQty

      headerRow.appendChild(headerCell);
      headerCell = document.createElement("th");
      headerCell.classList.add("option-price");
      headerCell.innerHTML = labels.productPriceLabel; //labels.optionPrice

      headerRow.appendChild(headerCell);
      return headerRow;
    }
  }, {
    key: "BuildNotSelectedRow",
    value: function BuildNotSelectedRow(optionGroupId) {
      var optionRow = document.createElement("tr");
      optionRow.innerHTML = "\n\t\t\t<td class=\"option-name\">\n\t\t\t\t<label>\n\t\t\t\t\t<input type=\"radio\" class=\"product-radio\" id=\"product-radio_".concat(optionGroupId, "\" name=\"product-radio_").concat(optionGroupId, "\" value=\"\" checked=\"checked\" />\n\t\t\t\t\tNot Selected\n\t\t\t\t\t<span class=\"mppw-radio\"></span>\n\t\t\t\t</label>\n\t\t\t</td>\n\t\t\t<td class=\"option-qty\">\n\t\t\t\t&nbsp;\n\t\t\t</td>\n\t\t\t<td class=\"option-price\">\n\t\t\t\t&nbsp;\n\t\t\t</td>");
      return optionRow;
    }
  }, {
    key: "BuildOptionRow",
    value: function BuildOptionRow(groupData, rowData) {
      var optionRow = document.createElement("tr");
      var optionCell;
      optionCell = document.createElement("td");
      optionCell.classList.add("option-name");
      var disabledElement = "",
          mppwRadioClass = "mppw-radio",
          mppwCheckboxClass = "mppw-checkbox",
          cursorStatus = "pointer-cursor";

      if (rowData.qtyOnHand !== undefined && rowData.qtyOnHand !== null && rowData.qtyOnHand <= 0) {
        optionRow.classList.add("mppw-event-gray-out");
        disabledElement = "disabled";
        mppwRadioClass = "mppw-radio-gray-out";
        mppwCheckboxClass = "mppw-checkbox-gray-out";
        cursorStatus = "default-cursor";
      }

      if (!!groupData.mutuallyExclusive) {
        optionCell.innerHTML = "\n\t\t\t\t<label class=\"product-selection-container ".concat(cursorStatus, "\" >\n\t\t\t\t\t<input type=\"radio\" ").concat(!!groupData.required ? "required" : "", " class=\"product-radio\" id=\"product-radio_").concat(rowData.optionPriceId, "\" name=\"product-radio_").concat(groupData.optionGroupId, "\" value=\"").concat(rowData.optionPriceId, "\" ").concat(disabledElement, " />\n\t\t\t\t\t").concat(rowData.optionTitle, "\n\t\t\t\t\t<span class=\"").concat(mppwRadioClass, "\"></span>\n\t\t\t\t</label>");
      } else {
        optionCell.innerHTML = "\n\t\t\t\t<label class=\"product-selection-container ".concat(cursorStatus, "\" >\n\t\t\t\t\t<input type=\"checkbox\" ").concat(!!groupData.required ? "required" : "", " class=\"product-checkbox\" data-checkbox-group=\"product-checkbox-group_").concat(groupData.optionGroupId, "\" id=\"product-checkbox_").concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" name=\"product-checkbox_").concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" ").concat(disabledElement, " />\n\t\t\t\t\t").concat(rowData.optionTitle, "\n\t\t\t\t\t<span class=\"").concat(mppwCheckboxClass, "\"></span>\n\t\t\t\t</label>");
      }

      if (!!groupData.noteLabel) {
        optionCell.innerHTML += "<div><input type=\"text\" data-ignore-validation=\"true\" id=\"product-note_".concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" placeholder=\"").concat(groupData.noteLabel, "\" name=\"product-note_").concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" /></div>");
      }

      optionCell.innerHTML += "<input type=\"hidden\" id=\"product-option-invoice-detail_".concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" name=\"product-option-invoice-detail_").concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" />");
      optionRow.appendChild(optionCell);
      optionCell = document.createElement("td");
      optionCell.classList.add("option-qty");
      var qtyRemaining = rowData.qtyOnHand || rowData.qtyAllowed;

      if (qtyRemaining > 1) {
        var maxQty = Math.min(rowData.qtyAllowed, qtyRemaining); // rowData.qtyAllowed > rowData.qtyOnHand ? rowData.qtyOnHand : rowData.qtyAllowed;

        if (maxQty > 1) {
          var qtySelect = document.createElement("select");
          qtySelect.setAttribute("data-ignore-validation", "true");
          qtySelect.setAttribute("name", "product-qty_".concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId));
          qtySelect.setAttribute("id", "product-qty_".concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId));
          qtySelect.setAttribute("class", 'product-select');

          if (disabledElement !== "") {
            qtySelect.setAttribute("disabled", true);
          }

          var minQty = rowData.minQty || 1;

          for (var q = minQty; q < maxQty + 1; q++) {
            var qtyOption = document.createElement("option");
            qtyOption.innerHTML = q;
            qtySelect.appendChild(qtyOption);
          }

          optionCell.appendChild(qtySelect);
        } else {
          optionCell.innerHTML = "1<input type=\"hidden\" id=\"product-qty_".concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" name=\"product-qty_").concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" value=\"1\" />");
        }
      } else {
        optionCell.innerHTML = "1<input type=\"hidden\" id=\"product-qty_".concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" name=\"product-qty_").concat(groupData.optionGroupId, "_").concat(rowData.optionPriceId, "\" value=\"1\" />");
      }

      optionRow.appendChild(optionCell);
      optionCell = document.createElement("td");
      optionCell.classList.add("option-price");
      optionCell.innerHTML = NumberUtils.toCurrencyString(rowData.optionPrice);
      optionRow.appendChild(optionCell);
      return optionRow;
    }
  }, {
    key: "BuildPromoCodeRow",
    value: function BuildPromoCodeRow(table, promoCode, amount, mutuallyExclusiveGroupId, context) {
      if (!table.querySelector("input[name=\"promo_".concat(promoCode, "\"]"))) {
        var hiddenField = document.createElement("INPUT");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "promo_".concat(promoCode));
        hiddenField.setAttribute("data-amount", amount);

        if (!!mutuallyExclusiveGroupId) {
          hiddenField.setAttribute("data-exclusivegroupid", mutuallyExclusiveGroupId);
        }

        hiddenField.value = promoCode;
        var row = document.createElement("TR"); //Promo code column:

        var promoCodeCell = document.createElement("TD");
        var promoCodeText = document.createElement("SPAN");
        promoCodeText.setAttribute("class", "promo-code-text");
        promoCodeText.innerHTML = promoCode;
        promoCodeCell.appendChild(hiddenField);
        promoCodeCell.appendChild(promoCodeText); //Discount amount column:

        var discountAmountCell = document.createElement("TD");
        var discountAmount = NumberUtils.toCurrencyString(amount);
        discountAmountCell.setAttribute("class", "promo-code-discount-text");
        discountAmountCell.innerHTML = discountAmount; //Remove button column:

        var removeCell = document.createElement("TD");
        removeCell.setAttribute("class", "mppw-centered");
        var removeLink = document.createElement("A");
        removeLink.setAttribute("href", "");
        removeLink.innerHTML = context._i18n.removePromoCodeButtonLabel;
        removeLink.addEventListener("click", function (event) {
          event.preventDefault();
          table.removeChild(row);
          context.UpdateTotal();

          if (table.rows.length > 1) {
            table.style.display = "";
          } else {
            table.style.display = "none";
          }
        });
        removeCell.appendChild(removeLink);
        row.appendChild(promoCodeCell);
        row.appendChild(discountAmountCell);
        row.appendChild(removeCell);
        table.appendChild(row);
      }
    }
  }, {
    key: "CalculateTotal",
    value: function CalculateTotal(productForm, productData, eventParticipants, selectedEventParticipantId) {
      var total = productData === null || productData === void 0 ? void 0 : productData.basePrice; // Calculate total based on product options selected in the form

      var _iterator3 = _createForOfIteratorHelper(productForm),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var elem = _step3.value;

          if (elem.name.startsWith("product-checkbox") && elem.checked) {
            (function () {
              var values = elem.name.split("_");
              var optionGroupId = +values[1];
              var optionPriceId = +values[2];
              var qtyField = productForm["product-qty_".concat(optionGroupId, "_").concat(optionPriceId)];
              var qty = qtyField.tagName === 'SELECT' ? +qtyField.options[qtyField.selectedIndex].value : +qtyField.value;
              var group = productData.optionGroups.find(function (g) {
                return g.optionGroupId == optionGroupId;
              });
              var price = group.optionPrices.find(function (p) {
                return p.optionPriceId == optionPriceId;
              });
              total += qty * price.optionPrice;
            })();
          }

          if (elem.name.startsWith("product-radio") && elem.checked) {
            if (!!elem.value) {
              (function () {
                var values = elem.name.split("_");
                var optionGroupId = +values[1];
                var optionPriceId = +elem.value;
                var qtyField = productForm["product-qty_".concat(optionGroupId, "_").concat(optionPriceId)];
                var qty = +qtyField.value;
                var group = productData.optionGroups.find(function (g) {
                  return g.optionGroupId == optionGroupId;
                });
                var price = group.optionPrices.find(function (p) {
                  return p.optionPriceId == optionPriceId;
                });
                total += qty * price.optionPrice;
              })();
            }
          }

          if (elem.name.startsWith("promo_")) {
            var value = elem.dataset.amount;
            total += +value;
          }
        } // Include the line totals from event participants

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (eventParticipants) {
        var participantsTotal = parseFloat(this.CalculateParticipantsTotal(eventParticipants, selectedEventParticipantId)); // Ensure the total does not drop below zero before adding participantsTotal

        total = Math.max(0, total);
        total += participantsTotal;
      } // Ensure the total does not drop below zero


      total = Math.max(0, total);
      return total.toFixed(2);
    }
  }, {
    key: "CalculateParticipantsTotal",
    value: function CalculateParticipantsTotal(eventParticipants, selectedEventParticipantId) {
      var total = 0; // Sum up the line totals from all event participants, ensuring they are non-negative

      if (eventParticipants) {
        var _iterator4 = _createForOfIteratorHelper(eventParticipants),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var participant = _step4.value;

            // Skip the selected participant when calculating the total
            if (selectedEventParticipantId === null || participant.eventParticipantId !== selectedEventParticipantId) {
              var participantTotal = Math.max(0, participant.lineTotal);
              total += participantTotal;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } // Ensure the total does not drop below zero and format to two decimal places


      total = Math.max(0, total);
      return total.toFixed(2); // Return the computed total formatted as a string
    }
  }]);

  return ProductFormBuilder;
}();